/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { connect } from "react-redux";
import { createStyles } from "@material-ui/core/styles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

import { Avatar } from "@material-ui/core";
import { Face } from "@material-ui/icons";

import { sPostHere } from "assets/jss/views/ResStrings";

import postsStyle from "assets/jss/views/coursePage/postsStyle";
const styles = createStyles(postsStyle as any);

import { PostActionType } from "./PostsZone";

export type PostEntryType = any;

interface Props extends WithStyles<typeof styles> {
  user: any;
  classes: any;
  // component props:
  state: string;
  post: PostEntryType;
  replyTo?: string;
  inPanel?: boolean;
  entryAction: (params: PostActionType) => void;
}

const PostEntryBase: React.FC<Props> = ({
  user,
  classes,
  // component props:
  state,
  post,
}: Props) => {
  const postReady = () => {
    return <div className={classes.postReady}>{sPostHere}</div>;
  };

  const postHeaderInfo = (name: string) =>
    post._id ? (
      <div className={classes.postInfo}>
        <p className={classes.postName}>{name}</p>
      </div>
    ) : (
      <div className={classes.postInfo}>
        <p className={classes.postName}>{name || "Welcome"}</p>
      </div>
    );

  const postHeader = () => {
    var avatar;
    const { picture, name } = state === "static" ? post : user;
    if (!picture) {
      var idx: number;
      const uid = post.user || user._id;
      if (uid === undefined) {
        avatar = (
          <Avatar variant="rounded" className={classes.avatar1}>
            <Face />
          </Avatar>
        );
      } else {
        idx = parseInt(uid.charAt(uid.length - 1), 16) % 5;
        avatar = (
          <Avatar variant="rounded" className={classes[`avatar${idx}`]}>
            <Face />
          </Avatar>
        );
      }
    } else {
      avatar = <Avatar variant="rounded" src={picture} />;
    }

    return (
      <div className={classes.postHeader}>
        <span className={classes.postAvatar}>{avatar}</span>
        {postHeaderInfo(name)}
      </div>
    );
  };

  const postBody = () => {
    return <div className={classes.postBody}>{postReady()}</div>;
  };

  // shift comment 1rem right
  return (
    <div className={classes.postIt}>
      {postHeader()}
      {postBody()}
    </div>
  );
};

function mapStateToProps(state: any) {
  return {
    user: state.state_auth,
  };
}

const base: any = PostEntryBase;
export const PostEntry: any = withStyles(styles)(
  connect(mapStateToProps)(base),
);

export const PostEntryTest = withStyles(styles)(PostEntryBase);
